<template>
	<div class="header-main">
		<el-header style="height: 100%">
			<div class="header-box">
				<div class="logobox flexStart">
					<h1 class="logo">
						<a @click="goHome">
							<img src="@/assets/images/20260303-132939.png" title="特规通" />
							<span class="logo-text">特规通</span>
						</a>
					</h1>
				</div>

				<NavList></NavList>

				<div class="nav-btnbox">
					<div class="btn-base btn-download">
						<el-button icon="el-icon-download" type="success" plain @click="toDownload">App 下载</el-button>
					</div>
					<div class="btn-base btn-member">
						<el-button icon="el-icon-medal" type="warning" plain @click="openFloatBox">会员权益</el-button>
					</div>
					<template>
						<div class="btn-base btn-login">
							<el-button plain type="primary" @click="openLogin('personal')">
								<a>个人登录</a>
							</el-button>
							<el-button plain type="primary" @click="openLogin('enterprise')">
								<a>企业登录</a>
							</el-button>
						</div>
					</template>
				</div>
			</div>
		</el-header>
		<!-- 个人登录 -->
		<LoginBoxPersonal v-if="sLoginShowPersonal" ref="loginboxPersonal" @success="onLoginSuccess" @register="register"></LoginBoxPersonal>
		<!-- 企业登录 -->
		<LoginBoxEnterprise v-if="sLoginShowEnterprise" ref="loginboxEnterprise" @success="onLoginSuccess" @register="register"></LoginBoxEnterprise>
		<!-- 企业选择 -->
		<ChangeCompany v-if="sCompanySelectorShow" ref="changeCompanyRef" @selected="onCompanySelected" />
		<!-- 注册 -->
		<RegisterBox ref="registerbox" @login="login"></RegisterBox>
		<VIPInfo ref="VIPInfoDom"></VIPInfo>
	</div>
</template>
<script>
	import Y from '@/utils/Y';
	import { mapGetters, mapActions } from 'vuex';
	import NavList from '@/components/NavList/index.vue';
	import LoginBoxPersonal from '@/components/LoginBoxPersonal/index.vue';
	import LoginBoxEnterprise from '@/components/LoginBoxEnterprise/index.vue';
	import ChangeCompany from '@/components/ChangeCompany/index.vue';
	import RegisterBox from '@/components/RegisterBox/index.vue';
	import VIPInfo from './VIPInfo.vue';
	import ExpiredBadgePopover from './ExpiredBadgePopover.vue';
	import User from '@/utils/User.js';
	import CUser from '@/utils/User';
	import FileInfo from '@/utils/GetFileUrl.js';
	import { SITE_URL } from '@/data/siteConfig';
	import { goLoginRedirect } from '@/utils/complianceEntry';

	export default {
		data() {
			return {
				userPhoto: require('@/assets/images/user.png'),
				avatarUrl: ''
			};
		},
		components: {
			NavList,
			LoginBoxPersonal,
			LoginBoxEnterprise,
			ChangeCompany,
			VIPInfo,
			RegisterBox,
			ExpiredBadgePopover
		},
		computed: {
			...mapGetters('User', ['uinfo', 'cinfo', 'uisLogin', 'uhasUnpaidOrder']),
			...mapGetters('Settings', ['sLoginRouteList', 'sLoginShowPersonal', 'sLoginShowEnterprise', 'sCompanySelectorShow', 'sPendingCompanyList']),

			// VIP状态相关计算属性
			vipStatus() {
				if (!this.uinfo || !this.uinfo.levelId || !this.uinfo.levelEnd) {
					return {
						isVip: false,
						isExpired: false,
						showIcon: false
					};
				}

				const now = new Date();
				const levelEnd = new Date(this.uinfo.levelEnd);
				const isExpired = levelEnd < now;

				return {
					isVip: true,
					isExpired: isExpired,
					showIcon: true
				};
			},
			// VIP图标颜色
			vipIconColor() {
				if (!this.vipStatus.showIcon) return 'transparent';
				return this.vipStatus.isExpired ? '#999999' : 'rgb(255, 186, 45)';
			},

			// 显示用户名（手机号中间4位脱敏）
			displayUserName() {
				if (this.uinfo.nickName) return this.uinfo.nickName;
				if (this.uinfo.realName) return this.uinfo.realName;
				if (this.uinfo.accountPhone) {
					const phone = this.uinfo.accountPhone;
					return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
				}
				return this.uinfo.accountCode || '';
			},

			// 到期时间badge显示条件：有endTime 且 当前时间在 endTime 前1个月和后1个月之间
			showExpiredBadge() {
				if (!this.cinfo.endTime) return false;
				const now = new Date();
				const endTime = new Date(this.cinfo.endTime);
				const oneMonthBefore = new Date(endTime);
				oneMonthBefore.setMonth(oneMonthBefore.getMonth() - 1);
				const oneMonthAfter = new Date(endTime);
				oneMonthAfter.setMonth(oneMonthAfter.getMonth() + 1);
				return now >= oneMonthBefore && now <= oneMonthAfter && this.cinfo.corporateLevel !== 0;
			}
		},

		watch: {
			sCompanySelectorShow: {
				handler(val) {
					if (val) {
						this.$nextTick(() => {
							this.$refs.changeCompanyRef && this.$refs.changeCompanyRef.open(this.sPendingCompanyList);
						});
					}
				},
				immediate: true
			},
			'uinfo.avatar': {
				async handler(newVal, oldVal) {
					if (newVal) {
						const prefix = '/third/files/info/';
						const key = newVal.replace(prefix, '');
						this.avatarUrl = await FileInfo.getFileUrl(key);
					} else {
						this.avatarUrl = this.userPhoto;
					}
				},
				immediate: true,
				deep: true
			}
		},

		created() {
			// 购物车入口已移除，无需初始化
		},
		methods: {
			register() {
				this.setLoginShowPersonal(false);
				this.setLoginShowEnterprise(false);
				this.setRegisterShow(true);
			},

			login() {
				this.setRegisterShow(false);
				this.setLoginShowPersonal(true);
			},

			openOrderPage() {
				if (this.uisLogin) {
					this.toRoute('/UserCenter/BookOrder');
				} else {
					this.setLoginShow(true);
				}
			},
			
			// 格式化VIP过期时间
			formatVIPDate(dateStr) {
				if (!dateStr) return '';
				const date = new Date(dateStr);
				const now = new Date();
				const diffTime = date - now;
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

				if (diffDays < 0) {
					return `已过期${Math.abs(diffDays)}天`;
				} else if (diffDays === 0) {
					return '今天到期';
				} else if (diffDays <= 7) {
					return `还有${diffDays}天到期`;
				} else {
					return date.toLocaleDateString('zh-CN');
				}
			},

			// 获取VIP提示信息
			getVIPTips() {
				if (!this.vipStatus.showIcon) return '';
				if (this.vipStatus.isExpired) {
					return `VIP已过期 (${this.formatVIPDate(this.uinfo.levelEnd)})`;
				} else {
					return `VIP会员 (${this.formatVIPDate(this.uinfo.levelEnd)})`;
				}
			},

			// 获取显示的会员等级名称
			getDisplayLevelName() {
				return this.cinfo.corporateLevel == 0 || !this.cinfo.corporateLevel ? '基础版' : this.cinfo.corporateLevel == 1 ? '专业版' : '旗舰版';
			},

			// 获取会员等级链接类型
			getLevelLinkType() {
				return this.cinfo.corporateLevel == 0 || !this.cinfo.corporateLevel ? 'info' : this.cinfo.corporateLevel == 1 ? 'primary' : 'warning';
			},

			// 去首页
			goHome() {
				this.toRoute('/Home');
			},

			// 去指定路由
			toRoute(path) {
				let pathname = window.location.pathname;
				if (pathname == '/ai' || pathname == '/AI') {
					const targetRoute = this.$router.resolve({
						path
					});
					window.open(targetRoute.href, '_blank');
				} else {
					this.$router.push({ path });
				}
			},

			// 弹出窗口
			openFloatBox() {
				this.toRoute('/Version');
			},

			// 去 App 下载页
			toDownload() {
				this.toRoute('/Download');
			},

			// 登录后执行
			onLoginSuccess() {
				// 登录成功回调
			},

			// 去书架
			openBookPage() {
				if (this.uisLogin) {
					this.toRoute('/BookCenter/BuyList');
				} else {
					this.setLoginShow(true);
				}
			},

			//去个人中心
			openUserPage() {
				if (this.uisLogin) {
					if (this.cinfo.isMain) {
						this.toRoute('/UserCenter/UserAccount');
					} else {
						this.toRoute('/UserCenter/UserInfo');
					}
				} else {
					this.setLoginShow(true);
				}
			},

			// 退出登录
			onLogout() {
				Y.confirm('确定要退出登录吗？').then(rlt => {
					if (rlt.confirm) {
						this.logout().then(() => {
							this.clearAll();
						});
					}
				});
			},

			// 升级VIP会员
			upgradeVIP() {
				if (this.uisLogin) {
					this.toRoute('/VIPList');
				} else {
					this.setLoginShow(true);
				}
			},

			// 打开登录窗口 -- 区分企业和个人
			openLogin(type) {
				if (type === 'enterprise') {
					this.setLoginShowEnterprise(true);
				} else {
					this.setLoginShowPersonal(true);
				}
			},

			// 点击待支付订单红点
			handleUnpaidOrderClick() {
				if (!this.uhasUnpaidOrder) return;
				this.$confirm('订单中有待支付的订单，是否去支付？', '提示', {
					confirmButtonText: '去支付',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.$router.push({ path: '/UserCenter/BookOrder', query: { tradeStatus: 0 } });
					})
					.catch(() => {});
			},

			// 企业选择完成
			async onCompanySelected(company) {
				this.setCompanySelectorShow(false);
				this.setPendingCompanyList([]);
				this.chooseCorporate(company);
				// 跳转到企业版：跨端口/子域名 localStorage 不共享，需通过 URL 传递企业信息
				// 智能工具打标时先由总入口判定旗舰版权限，有权限则直跳合规系统
				await goLoginRedirect(SITE_URL.COMPANY, CUser.getToken(), company);
			},

			...mapActions('User', ['logout', 'postConsumerOrderList', 'chooseCorporate']),
			...mapActions('Cart', ['clearAll']),
			...mapActions('Settings', ['setLoginShow', 'setLoginShowPersonal', 'setLoginShowEnterprise', 'setRegisterShow', 'setCompanySelectorShow', 'setPendingCompanyList'])
		}
	};
</script>

<style lang="less" scoped>
	// 已登录用户头像区域
	.header-user-info {
		cursor: pointer;
		position: relative;
		padding: 4px 12px;
		transition: all 0.2s;
		display: flex;
		align-items: center;

		&:hover {
			background: #eff6ff;
			border-radius: 8px;
		}
	}

	.header-user-ref {
		margin-left: 8px;
		min-width: 0;
		flex: 1;
	}

	.header-user-name {
		display: block;
		color: #0f172a;
		font-weight: 500;
		font-size: 14px;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 120px;
	}

	.header-user-company {
		font-size: 12px;
		color: #64748b;
		margin: 0;
		line-height: 1.3;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 120px;
	}

	.vip-icon {
		position: absolute;
		top: -8px;
		right: -13px;
		font-size: 25px;
		line-height: 1;
	}
	// 弹窗外框 - 匹配 lz_project shadow-xl rounded-xl border border-slate-200
	/deep/ .popover-main {
		border: 1px solid #e2e8f0 !important;
		border-radius: 12px !important;
		box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
		padding: 8px 0 !important;
	}

	// 用户信息区 - 匹配 lz_project px-4 py-3 border-b border-slate-100
	.popover-main-info {
		padding: 16px;
		border-bottom: 1px solid #dcdfe6;
	}

	.popover-user-info {
		display: flex;
		align-items: flex-start;
	}

	.popover-user-text {
		flex: 1;
		margin-left: 12px;
		min-width: 0;

		.user-name {
			font-size: 16px;
			font-weight: 600;
			color: #0f172a;
			display: block;
			line-height: 1.4;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			margin-right: 8px;
		}

		.enterprise-name {
			font-size: 12px;
			color: #64748b;
			margin: 4px 0 12px;
			line-height: 1.4;
			overflow: hidden;
			// text-overflow: ellipsis;
			// white-space: nowrap;
		}
	}

	.popover-info-row {
		display: flex;
		align-items: baseline;
		margin-left: -7px;

		.info-label {
			// width: 72px;
			flex-shrink: 0;
			font-size: 12px;
			color: #64748b;
		}

		.info-value {
			flex: 1;

			.expired-date-info {
				display: block;
				font-size: 13px;
				color: #64748b;
			}
		}
	}

	// 底部按钮区 - 匹配 lz_project 菜单项样式
	.popover-btn {
		background: none !important;
		display: flex;
		flex-direction: column;
		padding: 4px 0 !important;

		// 菜单项 - 匹配 lz_project px-4 py-2 hover:bg-slate-50
		.el-link {
			width: 100%;
			text-align: left;
			padding: 10px 16px;
			font-size: 14px;
			color: #334155 !important;
			font-weight: 400;
			border-radius: 0;
			transition: background 0.15s;
			line-height: 1.4;
			margin-left: 0;
			box-sizing: border-box;

			&:hover {
				background: #f8fafc;
				text-decoration: none;
			}

			&.order-link {
				position: relative;
			}

			// 退出登录 - 匹配 lz_project text-red-600 hover:bg-red-50
			&:last-child {
				border-top: 1px solid #dcdfe6;
				color: #dc2626 !important;
				margin-top: 4px;

				&:hover {
					background: #fef2f2;
				}
			}
		}
	}

	.header-main {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 50;
		background: #ffffff;
		border-bottom: 1px solid #e2e8f0;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		height: 68px;
		padding: 0;
		transition: height 0.3s ease;
	}

	.to-indigo-600 {
		--tw-gradient-to: var(--color-indigo-600);
		--tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
	}

	.header-box {
		width: 100%;
		max-width: 1280px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 24px;
		box-sizing: border-box;
		height: 100%;
	}

	.logobox {
		flex-shrink: 0;
	}

	.logo {
		display: flex;
		align-items: center;
		height: 40px;
		margin: 0;
		flex-shrink: 0;
		cursor: pointer;
		gap: 10px;

		a {
			display: flex;
			align-items: center;
			height: 100%;
			gap: 10px;
			text-decoration: none;

			img {
				height: 28px;
				width: auto;
			}
		}

		.logo-text {
			font-size: 20px; // text-xl
			font-weight: 800; // font-bold
			// 匹配 lz_project bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent
			background: linear-gradient(to right, #2563eb, #4f46e5);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
		}
	}

	// 导航右侧按钮区
	.nav-btnbox {
		display: flex;
		align-items: center;
		flex-shrink: 0;
		gap: 4px;

		.btn-base {
			display: flex;
			align-items: center;
		}
	}

	// 按钮基础样式
	.btn-base .el-button {
		height: 36px;
		line-height: 36px;
		padding: 0 18px;
		border-radius: 10px;
		font-size: 14px;
		font-weight: 500;
		transition: all 0.2s ease;
		white-space: nowrap;
		border: none;
		//margin-right: 14px;
	}

	.btn-member .el-button {
		height: 36px;
		line-height: 36px;
		padding: 0 18px;
		border-radius: 10px;
		font-size: 14px;
		font-weight: 500;
		transition: all 0.2s ease;
		white-space: nowrap;
		border: none;
		margin-right: 14px;
		margin-left: 14px;
	}

	// App 下载按钮 - 绿色渐变突出
	.btn-download .el-button {
		height: 36px;
		line-height: 36px;
		padding: 0 18px;
		border-radius: 10px;
		font-size: 14px;
		font-weight: 600;
		transition: all 0.2s ease;
		white-space: nowrap;
		border: none;
		background: linear-gradient(135deg, #22c55e, #10b981);
		color: #ffffff;
		box-shadow: 0 2px 8px rgba(34, 197, 94, 0.25);

		&:hover {
			opacity: 0.9;
			color: #ffffff;
			box-shadow: 0 4px 12px rgba(34, 197, 94, 0.35);
		}
	}

	// .btn-member .el-button {
	// 	background: transparent;
	// 	color: #64748b;
	// 	font-weight: 500;
	// 	box-shadow: none;

	// 	&:hover {
	// 		color: #2563eb;
	// 		background: #eff6ff;
	// 	}
	// }

	// .btn-member .el-button--primary {
	// 	color: #64748b;
	// 	font-size: 14px;
	// 	font-weight: 500;
	// }

	// 登录按钮 - 蓝靛渐变
	.btn-login .el-button {
		padding: 0 20px;
		background: linear-gradient(135deg, #2563eb, #4f46e5);
		color: #ffffff;
		font-weight: 500;
		box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
		border-radius: 10px;

		&:hover {
			opacity: 0.9;
			box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
		}
	}

	.btn-login .el-button--primary {
		color: #ffffff;
		font-size: 14px;
		font-weight: 500;
	}

	// 已登录用户头像区域
	/deep/ .el-popover {
		.el-avatar {
			border: 2px solid #e2e8f0;
			transition: border-color 0.2s;

			&:hover {
				border-color: #2563eb;
			}
		}
	}

	// ========== 响应式 ==========
	@media screen and (max-width: 767px) {
		.header-main {
			height: 56px !important;
		}

		.header-box {
			padding: 0 12px;
		}

		.logo {
			height: 30px;
			gap: 6px;
			a {
				gap: 6px;
				img {
					height: 24px;
				}
			}
			.logo-text {
				font-size: 17px;
				font-weight: 800;
			}
		}

		.nav-btnbox {
			gap: 6px;

			.btn-member {
				display: none;
			}

			.el-button {
				height: 32px;
				line-height: 32px;
				padding: 0 10px;
				font-size: 13px;
			}

			.btn-login .el-button {
				padding: 0 12px;
				font-size: 13px;
			}
		}

		.header-user-info {
			padding: 2px 6px;
		}

		.header-user-ref {
			display: none;
		}

		.header-user-name {
			display: none;
		}
		.header-user-company {
			display: none;
		}

		.vip-icon {
			top: -6px;
			right: -10px;
			font-size: 20px;
		}
	}

	@media screen and (min-width: 768px) and (max-width: 1024px) {
		.header-main {
			height: 64px !important;
		}

		.header-box {
			padding: 0 18px;
		}

		.logo {
			height: 36px;
			gap: 8px;
			a {
				gap: 8px;
				img {
					height: 30px;
				}
			}
			.logo-text {
				font-size: 19px;
				font-weight: 800;
			}
		}

		.nav-btnbox {
			gap: 10px;

			.btn-base .el-button {
				font-size: 13px;
				padding: 0 12px;
				height: 34px;
				line-height: 34px;
			}

			.btn-member .el-button {
				font-size: 13px;
				padding: 0 12px;
				height: 34px;
				line-height: 34px;
				margin-right: 8px;
				margin-left: 8px;
			}
		}

		.header-user-info {
			padding: 2px 8px;
		}

		.header-user-ref {
			margin-left: 6px;
		}

		.header-user-name {
			font-size: 13px;
			max-width: 80px;
		}

		.header-user-company {
			font-size: 11px;
			max-width: 80px;
		}

		.vip-icon {
			top: -7px;
			right: -11px;
			font-size: 22px;
		}
	}

	@media screen and (min-width: 1025px) {
		.header-box {
			max-width: 1280px;
		}

		.logo .logo-text {
			font-size: 22px;
			font-weight: 800;
		}
		.logo a img {
			height: 32px;
		}

		.header-user-name {
			font-size: 14px;
		}

		.header-user-company {
			font-size: 12px;
		}
	}

	@media screen and (min-width: 1601px) {
		.header-box {
			max-width: 1330px;
		}

		.logo .logo-text {
			font-size: 24px;
			font-weight: 800;
		}
		.logo a img {
			height: 34px;
		}

		.header-user-ref {
			margin-left: 10px;
		}

		.header-user-name {
			font-size: 15px;
			max-width: 140px;
		}

		.header-user-company {
			font-size: 13px;
			max-width: 140px;
		}

		.vip-icon {
			top: -9px;
			right: -14px;
			font-size: 27px;
		}
	}
</style>
<style lang="less">
	.el-popover {
		min-width: 100px !important;
	}

	.popover-main {
		padding: 0 !important;
		border-radius: 14px !important;
		overflow: hidden !important;
	}

	.header-order-badge {
		position: absolute;
		top: 8px;
		right: 74px;
		height: 8px;
		width: 8px;
		border-radius: 50%;
		background-color: #ef4444;
		border: 1px solid #ffffff;
	}
</style>
